import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050505] p-6 text-center text-white" data-testid="not-found-page">
      <div className="max-w-md">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl brand-bg">
          <AlertTriangle className="h-6 w-6 text-white" />
        </div>
        <h1 className="font-display mt-6 text-5xl font-light tracking-tight">404</h1>
        <p className="mt-2 text-white/55">This page doesn't exist — or it moved.</p>
        <Link to="/">
          <Button className="mt-6 rounded-full bg-white text-black hover:bg-zinc-200" data-testid="not-found-home">Back home</Button>
        </Link>
      </div>
    </div>
  );
}
